import { atom } from 'recoil'

export const sendingsState = atom({
  key: 'SMTPPlusSendStatusSendingsState',
  default: {
    dateFrom: undefined,
    estimated: undefined,
    totalCount: undefined,
    totalSent: undefined
  }
})
